import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAPKQoTCT1jniqKZ21fg26Y00yDFRATmC4",
    authDomain: "pd-kakaotalk.firebaseapp.com",
    projectId: "pd-kakaotalk",
    storageBucket: "pd-kakaotalk.appspot.com",
    messagingSenderId: "410797806898",
    appId: "1:410797806898:web:875388ea650c4f0dc8332b",
    measurementId: "G-CFPJ466PSK"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const provider = new firebase.auth.GoogleAuthProvider();
const auth = firebase.auth();
const db = firebaseApp.firestore();

export { auth, provider };
export default db;